import Api from "../Api";

class ApiInceptionsData extends Api {
  static getInceptionsData() {
    return ApiInceptionsData.instance.axiosInst.get(
      "/bond/index-performance-comparison/inceptions"
    );
  }
}

export default ApiInceptionsData;